// Texts for the world 'penguins': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Pingviner',
    scene: { slide: 'GLID!' },
    levels: {
      'slide': { title: 'Glid' },
      'snow-brakes': { title: 'Sne bremser' },
      'belly-penguin': { title: 'Mavepingvin' },
      'brake': { title: 'Bremse' },
      'far-away': { title: 'Langt væk' },
      'gravel': { title: 'Grus' },
      'penguin-run': { title: 'Pingvinbanen' },
      'flat-or-slope': { title: 'Flad eller skrå' },
      'bridge-and-brake': { title: 'Bro og bremse' },
      'three-chicks': { title: 'Tre unger' },
      'penguin-path': { title: 'Pingvinens vej' },
      'long-trip': { title: 'Lang tur' },
      'skiing': { title: 'Skiløb' },
      'seal': { title: 'Sælen' },
      'master-penguin': { title: 'Mesterpingvin' },
    },
  },
  en: {
    name: 'Penguins',
    scene: { slide: 'WHOOSH!' },
    levels: {
      'slide': { title: 'Slide' },
      'snow-brakes': { title: 'Snow slows you down' },
      'belly-penguin': { title: 'Belly-slide penguin' },
      'brake': { title: 'Brake' },
      'far-away': { title: 'Far away' },
      'gravel': { title: 'Gravel' },
      'penguin-run': { title: 'The penguin run' },
      'flat-or-slope': { title: 'Flat or sloping' },
      'bridge-and-brake': { title: 'Bridge and brake' },
      'three-chicks': { title: 'Three chicks' },
      'penguin-path': { title: 'The penguin\'s path' },
      'long-trip': { title: 'A long trip' },
      'skiing': { title: 'Skiing' },
      'seal': { title: 'The seal' },
      'master-penguin': { title: 'Master penguin' },
    },
  },
});
